const schedulerStorage = {
  state:{
    events:[]
  
  },
  mutations:{
  
  },
  action:{
  
  },
  getters:{
    getAllEvents (state) {
      return state.events
    }
  
  }
  
}
export default schedulerStorage
